import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  InternalAxiosRequestConfig
} from 'axios';
import { config as appConfig } from '../../config';
import auth from '../utils/auth';

export type RequestOptions = AxiosRequestConfig & {
  timeout?: number | null;
};
export class HttpError extends Error {
  response: Response;

  constructor(response: Response) {
    const { pathname } = new URL(response.url);
    const message = `${response.status} ${response.statusText} at ${pathname}`;
    super(message);
    this.name = this.constructor.name;
    this.response = response;

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}

let client: AxiosInstance | null = null;

type StbClientOptions = {
  forceProdApiRoot?: boolean;
};

export async function getStbClient({
  forceProdApiRoot
}: StbClientOptions = {}): Promise<AxiosInstance> {
  if (client == null) {
    const baseURL = await getBaseUrl(forceProdApiRoot);
    client = axios.create({
      baseURL,
      headers: { ClientId: appConfig.name }
    });
    registerInterceptors(client);
  }
  return client;
}

async function getBaseUrl(forceProdApiRoot = false): Promise<string> {
  if (forceProdApiRoot) {
    return 'https://api.storebrand.no';
  }

  const response = await axios.get<{ apihome: string }>('/api.json');
  return response.data.apihome;
}

function registerInterceptors(instance: AxiosInstance): void {
  instance.interceptors.request.use(automaticallyAuthorizedRequests);
}

async function automaticallyAuthorizedRequests(
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> {
  if (config.url?.includes('/open/') ?? true) {
    return config;
  }

  const token = await auth.getToken();

  config.headers.set({ Authorization: `Bearer ${token}` });

  return config;
}
